export const HUBSPOT_PORTAL_ID = process.env.REACT_APP_HUBSPOT_PORTAL_ID;

export const MEETING_OUTCOME = [
  {
    label: "Scheduled",
    value: "SCHEDULED",
  },
  {
    label: "Completed",
    value: "COMPLETED",
  },
  {
    label: "Rescheduled",
    value: "RESCHEDULED",
  },
  {
    label: "No Show",
    value: "NO_SHOW",
  },
  {
    label: "Canceled",
    value: "CANCELED",
  },
  {
    label: "Canvassed",
    value: "CANVASSED",
  },
];

export const HOUSE_DISPOSITION_OPTIONS = [
  {
    label: "Household Completed",
    value: "Household Completed",
    color: "#0AD041",
  },
  {
    label: "Household Partially Canvassed",
    value: "Household Partially Canvassed",
    color: "#FE852E",
  },
  {
    label: "No Answer",
    value: "No Answer",
    color: "#A9A9A9",
  },
  {
    label: "Not Attempted",
    value: "Not Attempted",
    color: "#000000",
  },
  {
    label: "Do not return",
    value: "Do not return",
    color: "#FF0000",
  },
  {
    label: "Contacted",
    value: "Contacted",
    color: "#0000FF",
  },
];

export const CANVASSING_LANGUAGE_BARRIER_OPTIONS = [
  {
    value: "Spanish Needed",
    label: "Spanish Needed",
    pin: "S",
  },
  {
    value: "Other Language",
    label: "Other Language",
    pin: "LB",
  },
];

export const ANALYTICS_SOURCE = [
  {
    label: "Organic Search",
    value: "ORGANIC_SEARCH",
  },
  {
    label: "Paid Search",
    value: "PAID_SEARCH",
  },
  {
    label: "Email Marketing",
    value: "EMAIL_MARKETING",
  },
  {
    label: "Organic Social",
    value: "SOCIAL_MEDIA",
  },
  {
    label: "Referrals",
    value: "REFERRALS",
  },
  {
    label: "Other Campaigns",
    value: "OTHER_CAMPAIGNS",
  },
  {
    label: "Direct Traffic",
    value: "DIRECT_TRAFFIC",
  },
  {
    label: "Offline Sources",
    value: "OFFLINE",
  },
  {
    label: "Paid Social",
    value: "PAID_SOCIAL",
  },
];

export const IncomeSTHHOption = Array.from({ length: 19 }, (_, i) =>
  String.fromCharCode(65 + i)
).map((letter) => ({ label: letter, value: letter }));
